module.exports = __webpack_public_path__ + "static/media/20180820-04-supplies-home-b-j-5-a-1760.0ecf8993.jpg";